import AtomicBlockIdentifiers from "../AtomicBlockIdentifiers";
import EditorMention from "../mentions/EditorMention";
import EntityTypeIdentifiers from "../EntityTypeIdentifiers";
import { convertFromHTML } from "draft-convert";
import { getYoutubeId } from "../utils";

/**
 * @type {Function}
 */
const translateIntoPlainContentState = convertFromHTML({
  /**
   * @param   {String}      tag
   * @param   {HTMLElement} node
   * @returns {?Object}
   */
  htmlToBlock: (tag, node) => {
    if (tag === "hr") {
      return {
        type: "atomic",
        data: {
          blockType: "divider",
        },
      };
    }

    if (tag === "img") {
      return {
        type: "atomic",
        data: {
          blockType: AtomicBlockIdentifiers.IMAGE,
          imageUrl: node.getAttribute("src"),
        },
      };
    }

    if (tag === "a" && node.href.includes("youtube.com")) {
      return {
        type: "atomic",
        data: {
          blockType: AtomicBlockIdentifiers.YOUTUBE_VIDEO,
          videoUrl: node.href,
          videoId: getYoutubeId(node.href),
        },
      };
    }

    return null;
  },

  /**
   * @param   {String}      nodeName
   * @param   {HTMLElement} node
   * @param   {OrderedSet}  currentStyle
   * @returns {OrderedSet}
   */
  htmlToStyle: (nodeName, node, currentStyle) => {
    if (nodeName === "mark") {
      return currentStyle.add("HIGHLIGHT");
    }

    return currentStyle;
  },

  /**
   * @param   {String}      nodeName
   * @param   {HTMLElement} node
   * @param   {Function}    createEntity
   * @returns {?String}
   */
  htmlToEntity: (nodeName, node, createEntity) => {
    if (nodeName === "a") {
      if (
        node.hasAttribute("class") &&
        node.getAttribute("class").includes("mention")
      ) {
        return null;
      }

      if (node.href.includes("youtube.com")) {
        return null;
      }

      return createEntity(EntityTypeIdentifiers.LINK, "MUTABLE", {
        url: node.href,
      });
    }

    if (nodeName === "span") {
      const jsonChildren = JSON.parse(node.textContent);

      if (
        jsonChildren &&
        jsonChildren.entityType &&
        jsonChildren.entityType === EntityTypeIdentifiers.MENTION
      ) {
        return createEntity(
          EntityTypeIdentifiers.MENTION,
          jsonChildren.mutability,
          EditorMention.create(
            jsonChildren.type,
            jsonChildren.displayText,
            jsonChildren.metadata,
            jsonChildren.mutability,
          ),
        );
      }
    }

    return null;
  },
});

export default translateIntoPlainContentState;
